/**
 * Purpose:
 *   Tailwind CSS class constants for Icon component.
 */

export const iconStyles = {
  container: `
    inline-block
  `,
};

